import { Injectable } from '@angular/core';
import { SocketService } from '@frontend/common/util';
import { createEffect } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import {
  GlobalCreateKioskSuccessWs,
  GlobalRemoveKioskSuccessWs,
  GlobalUpdateKioskSuccessWs,
  LocalCreateKioskFailureWs,
  LocalCreateKioskSuccessWs,
  LocalRemoveKioskFailureWs,
  LocalRemoveKioskSuccessWs,
  LocalUpdateKioskFailureWs,
  LocalUpdateKioskSuccessWs,
} from './kiosk-ws.actions';

@Injectable()
export class KioskWsEffects {
  LocalCreateKioskSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalSuccess('kiosks.create')
      .pipe(
        map(
          ({ id, correlation_id }) =>
            new LocalCreateKioskSuccessWs({ id, correlation_id })
        )
      )
  );

  LocalCreateKioskFailureWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalError('kiosks.create')
      .pipe(
        map(
          ({ correlation_id, message }) =>
            new LocalCreateKioskFailureWs({ correlation_id, message })
        )
      )
  );

  LocalUpdateKioskSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalSuccess('kiosks.update')
      .pipe(
        map(
          ({ id, correlation_id }) =>
            new LocalUpdateKioskSuccessWs({ id, correlation_id })
        )
      )
  );

  LocalUpdateKioskFailureWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalError('kiosks.update')
      .pipe(
        map(
          ({ correlation_id, message }) =>
            new LocalUpdateKioskFailureWs({ correlation_id, message })
        )
      )
  );

  LocalRemoveKioskSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalSuccess('kiosks.remove')
      .pipe(
        map(({ correlation_id }) => new LocalRemoveKioskSuccessWs({ correlation_id }))
      )
  );

  LocalRemoveKioskFailureWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalError('kiosks.remove')
      .pipe(
        map(
          ({ correlation_id, message }) =>
            new LocalRemoveKioskFailureWs({ correlation_id, message })
        )
      )
  );

  GlobalCreateKioskSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromGlobalSuccess('kiosks.create')
      .pipe(map(() => new GlobalCreateKioskSuccessWs()))
  );

  GlobalUpdateKioskSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromGlobalSuccess('kiosks.update')
      .pipe(map((kiosk: any) => new GlobalUpdateKioskSuccessWs({ kiosk })))
  );

  GlobalRemoveKioskSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromGlobalSuccess('kiosks.remove')
      .pipe(map(({ id }: any) => new GlobalRemoveKioskSuccessWs({ id })))
  );

  constructor(private socketSrv: SocketService) {}
}
